export class ProductAssistantFactory {
  constructor(instance) {
    this.instance = instance;
  }

  chat({ message, currentRoute, history = [] }) {
    return this.instance.post(
      '/v1/ia/assistant/chat',
      {
        message,
        currentRoute,
        history,
      },
      { timeout: 90000 },
    );
  }
}

export default ProductAssistantFactory;
